import { render, staticRenderFns } from "./dataProperties.vue?vue&type=template&id=1a11ac00&"
import script from "./dataProperties.vue?vue&type=script&lang=js&"
export * from "./dataProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports